import axios from './request'
const organization = {

    lists(params={}){
        return axios.post('/organization.html',params)
    }
}


const course={
    lists(params={}){
        return axios.post('/course/lists.html',params)
    },
    details(params={}){
        return axios.post('/course/details.html',params)
    }
}

const user={
    login(params={}){
        return axios.post('/login.html',params)
    },
    works(){
       
        return axios.post('v2/user/works2.html');
    },
    course(params={}){
        return axios.post('/user/course.html',params)
    },
    sms(params={}){
        return axios.post('/sms.html',params)
    }
}



const plan = {
    details(params={}){
        return axios.post('/plan/details.html',params)
    }
}

const learn={
    live(params={}){
        return axios.post('/v2/learn/live.html',params)
    },
    course(params={}){
        return axios.post('/learn/course.html',params)
    },
    selfstudy(params={}){
        return axios.post('/learn/independent.html',params)
    },
    courselog(params={}){
        return axios.post('/log/course.html',params)
    }
}

const base={
    uploads64(params={}){
        return axios.post('/uploads64.html',params)
    }
}



export default {
    organization,
    course,
    user,
    plan,
    base,
    learn
};